export default __webpack_public_path__ + "static/media/team4.75f47140.jpg";